import { useEffect, useState } from 'react';
import {
    Flex,
    VStack,
    Text,
    HStack,
    Box,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    CloseButton,
} from '@chakra-ui/react';
import { Outlet } from 'react-router';
import BottomNav from '../../components/Dashboard/BottomNav.js';
import FloatingMenu from '../../components/Dashboard/FloatingMenu.js';
import MobileMenu from '../../components/Dashboard/MobileMenu.js';
import DashHead from './components/DashHead.js';
import { cartIcon } from './components/Icons.js';
import Navigation from './components/Navigation.js';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get_all_products, get_categories } from 'redux/actions/productActions.js';
// import { get_store } from 'redux/actions/storeActions.js';
import { useScreenWidth } from 'hooks/useScreenWidth.js';
import logo from '../../assets/bigLogo.svg';
import {
    fetchCurrencies,
    selectCurrency,
    loadFromStorage,
    NGN_FALLBACK,
} from 'redux/actions/currencyActions.js';
import useGetUserDetails from 'hooks/useGetUserDetail.js';
import { isEmpty as _isEmpty } from 'lodash';
import DashCurrencySelector from './components/currency-selector.js';

const Dashboard = () => {
    const screen = useScreenWidth();
    const [pageTitle, setPageTitle] = useState('');
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useGetUserDetails();
    const decoded = user?.flattenedUser;
    const details = decoded?.attributes;
    const userName = details?.first_name || 'User';

    let title = location.pathname;

    const productReducer = useSelector((state) => state.productReducer);
    const currencies = useSelector((state) => state.currencyReducer.currencies);
    const { cartItems } = productReducer;

    const getPageTitle = () => {
        if (title === '/dashboard/import') setPageTitle('Wishlist');
        else setPageTitle('');
    };

    useEffect(() => {
        getPageTitle();
    });

    useEffect(() => {
        const saved = loadFromStorage();
        if (saved) {
            dispatch({ type: 'SET_CURRENCIES_RATES', payload: saved });
            dispatch({ type: 'SET_CURRENCY', payload: { currency: saved.symbol } });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!user || _isEmpty(currencies)) return;

        const userCurrency = details?.currency?.toUpperCase();
        if (!userCurrency) return;

        const stored = loadFromStorage();
        if (stored) return;

        const match = currencies.find(
            (c) =>
                (c.symbol?.toUpperCase() === userCurrency ||
                    c.code?.toUpperCase() === userCurrency) &&
                c.hasRate,
        );
        if (match) {
            dispatch(selectCurrency(match));
        } else {
            const ngn = currencies.find(
                (c) => c.symbol?.toUpperCase() === 'NGN' || c.code?.toUpperCase() === 'NGN',
            );
            dispatch(selectCurrency(ngn ?? NGN_FALLBACK));
        }
    }, [currencies]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const hasSeenPopup = localStorage.getItem('welcome_popup_seen');
        if (!hasSeenPopup) {
            const timer = setTimeout(() => {
                setShowWelcomeModal(true);
                localStorage.setItem('welcome_popup_seen', 'true');
            }, 1200);
            return () => clearTimeout(timer);
        }
    }, []);

    useEffect(() => {
        dispatch(get_all_products({ page: 1, per_page: 24 }));
        dispatch(get_categories());
        // dispatch(get_store());
        dispatch(fetchCurrencies());
    }, [dispatch]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const openModal = () => setIsModalOpen(true);
    let { isEmpty } = useParams();
    let displayhead = isEmpty === undefined;

    return (
        <>
            <Box
    position="relative"
    overflow="hidden"
    w="100vw"
    maxW="100vw"
    h={{ base: '28px', md: '32px' }}
    bg="#1b3b5f"
    sx={{
        '@keyframes obanaMarquee': {
            '0%':   { transform: 'translateX(100%)' },
            '100%': { transform: 'translateX(-100%)' },
        },
    }}
>
    <Box
        as="span"
        position="absolute"
        top="50%"
        left="0"
        transform="translateY(-50%)"
        whiteSpace="nowrap"
        color="#F0F0F0"
        fontSize={{ base: '11px', md: '13px' }}
        fontFamily="'Bricolage Grotesque', sans-serif"
        sx={{
            animation: 'obanaMarquee 35s linear infinite',
            willChange: 'transform',
        }}
    >
        Final prices displayed are subject to change depending on fluctuations in the exchange rate. Please also ensure you are aware of the currency you are placing your order in. You can use the currency selector below to switch currencies.
    </Box>
</Box>

            {screen <= 500 ? (
                <>
                    {displayhead && (
                        <HStack
                            px="14px"
                            justifyContent="space-between"
                            py="10px"
                            position="sticky"
                            top="0"
                            bg="white"
                            zIndex="1000"
                            boxShadow="sm"
                            alignItems="center">
                            <HStack spacing="8px">
                                <Box
                                    cursor="pointer"
                                    onClick={openModal}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    w="28px"
                                    h="28px">
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round">
                                        <line x1="3" y1="6" x2="21" y2="6" />
                                        <line x1="3" y1="12" x2="21" y2="12" />
                                        <line x1="3" y1="18" x2="21" y2="18" />
                                    </svg>
                                </Box>
                                <Box width="80px" height="34px">
                                    <img
                                        src={logo}
                                        alt="Logo"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </Box>
                            </HStack>

                            {pageTitle ? (
                                <Text fontWeight="700" fontSize="16px" flex="1" textAlign="center">
                                    {pageTitle}
                                </Text>
                            ) : (
                                <Box flex="1" />
                            )}

                            <HStack spacing="6px" alignItems="center">
                                <DashCurrencySelector size="small" />

                                <Box
                                    pos="relative"
                                    cursor="pointer"
                                    onClick={() => navigate('/dashboard/cart')}>
                                    {cartIcon}
                                    <Box
                                        pos="absolute"
                                        w="14px"
                                        h="14px"
                                        bg="#FCB61A"
                                        top="-6px"
                                        right="-6px"
                                        borderRadius="15px"
                                        fontWeight="800"
                                        fontSize="8px"
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center">
                                        {cartItems?.items?.length ?? 0}
                                    </Box>
                                </Box>
                            </HStack>
                        </HStack>
                    )}

                    <VStack w="90%" mx="auto">
                        <Outlet />
                    </VStack>
                    <FloatingMenu
                        isModalOpen={isModalOpen}
                        openModal={openModal}
                        closeModal={closeModal}
                        title={title}
                    />
                    <MobileMenu
                        isModalOpen={isModalOpen}
                        closeModal={closeModal}
                        setIsModalOpen={setIsModalOpen}
                        title={title}
                        userDetails={details}
                    />
                    <BottomNav title={title} isEmpty={isEmpty} />
                </>
            ) : (
                <Flex w="100%">
                    <Navigation />
                    <VStack width="100%" p="10px" spacing="0" bg="#fafafa" overflowX="auto">
                        <DashHead />
                        <Outlet />
                    </VStack>
                </Flex>
            )}

            <Modal isOpen={showWelcomeModal} onClose={() => setShowWelcomeModal(false)} isCentered>
                <ModalOverlay />
                <ModalContent maxW="md" borderRadius="2xl" p={6}>
                    <ModalHeader display="flex" justifyContent="space-between" alignItems="center">
                        <Text fontSize="lg" fontWeight="semibold">
                            Welcome Back!
                        </Text>
                        <CloseButton onClick={() => setShowWelcomeModal(false)} />
                    </ModalHeader>
                    <ModalBody pb={6}>
                        <Text color="gray.600" fontSize="sm" mb={4}>
                            Hi{' '}
                            <Text as="span" fontWeight="medium" color="gray.800">
                                {userName}
                            </Text>
                            , welcome to your dashboard 👋
                        </Text>
                        <Box
                            bg="gray.50"
                            p={3}
                            borderRadius="md"
                            borderWidth={1}
                            borderColor="gray.200">
                            <Text fontSize="sm" color="gray.700">
                                Join our exclusive{' '}
                                <Text as="span" fontWeight="semibold">
                                    WhatsApp Community
                                </Text>{' '}
                                to network, get updates, and access support directly.
                            </Text>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            as="a"
                            href="https://chat.whatsapp.com/BDBuFdqZCOs8Z4s2JXHGmM?mode=ac_t"
                            target="_blank"
                            rel="noopener noreferrer"
                            bg="green.600"
                            color="white"
                            _hover={{ bg: 'green.700' }}
                            leftIcon={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 32 32"
                                    fill="currentColor"
                                    width="18px"
                                    height="18px">
                                    <path d="M16 2.667A13.333 13.333 0 0 0 2.667 16c0 2.373.627 4.667 1.84 6.667L2.667 29.333l6.96-1.84A13.267 13.267 0 0 0 16 29.333 13.333 13.333 0 0 0 16 2.667zm0 24a10.56 10.56 0 0 1-5.333-1.493l-.373-.213-4.147 1.107 1.12-4.053-.24-.4A10.586 10.586 0 1 1 16 26.667zm5.04-7.067c-.267-.133-1.573-.773-1.813-.867-.24-.093-.413-.133-.587.134-.173.267-.68.867-.84 1.04-.16.173-.307.2-.573.067-.267-.133-1.12-.413-2.133-1.307-.787-.7-1.32-1.56-1.48-1.827-.16-.267-.017-.413.12-.547.12-.12.267-.307.4-.467.133-.16.173-.267.267-.44.093-.173.047-.333-.02-.467-.066-.133-.587-1.413-.8-1.933-.213-.52-.427-.453-.587-.46h-.507c-.16 0-.467.067-.713.333-.247.267-.933.913-.933 2.227 0 1.313.96 2.58 1.093 2.76.133.173 1.893 2.893 4.573 4.053.64.28 1.14.453 1.527.58.64.203 1.227.174 1.693.107.52-.08 1.573-.64 1.793-1.253.22-.613.22-1.14.153-1.253-.066-.113-.24-.173-.507-.306z" />
                                </svg>
                            }
                            size="sm"
                            fontSize="sm">
                            Join WhatsApp Community
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default Dashboard;
